import React, { useState, useEffect } from "react";
import Layout from "components/sales/layout/layout";
import Images, { ArrowRight, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import PanelCardWithHeading from "components/tickets/panelCardWithHeading";
import EmpCreateTicketForm from "components/tickets/formSection/empCreateTicketForm/empCreateTicketForm";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";

const EmpCreateTicket = ({
  history,
  createTicket,
  documentUploadUrl,
  documentUrlData,
  fetchSitesLocationMap,
  sitesLocMapList,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [createTicketData, setCreateTicketData] = useState(null);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);

  const createTicketHandle = async () => {
    if (createTicketData === null) {
      setIsFiled(true);
    } else {
      setIsFiled(false);
      setIsLoading(true);
      await createTicket(createTicketData);
      setIsLoading(false);
      setIsModal(true);
    }
  };
  const handleModalHide = () =>{ setIsModal(false); history.push(`/dashboard/sites-location-map`)}
  const headerBtns = () => {
    return (
      <Button
        className="btn btn-primary d-none d-md-inline-block"
        onClick={createTicketHandle}
      >
        {" "}
        {localization.raiseTicket} <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await fetchSitesLocationMap();
      setIsLoading(false);
    })();
  }, []);

  return (
    <Layout
      title={localization.createEmployeeTicket}
      Buttons={headerBtns}
      isLoading={isLoading}
      className={isFiled ? "requiredFileds" : ""}
    >
      <PanelCardWithHeading title={localization.createTicket}>
        <EmpCreateTicketForm
          sitesList={sitesLocMapList}
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          createTicketSubmit={(obj) => setCreateTicketData(obj)}
        />
      </PanelCardWithHeading>

      <ModalPop
        title={localization.saveSuccessfully}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.ticketSuccessfullyCreated}</h5>
          {/* <Button onClick={handleModalHide} className="btn btn-primary mb-4"> */}
          <Link
            to={`/dashboard/sites-location-map`}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default EmpCreateTicket;
